<template>
  <div>
    <div id="gridcontainer" style="width: 100%">
      <table id="upcomingTable" class="upcoming-table" style="width: 100%">
        <thead style="width: 100%">
          <tr id="upcomingTable-header-row">
            <th style="width: 0.75%">Dri</th>
            <th style="width: 1.0%">Time</th>
            <th style="width: 10%">Pickup</th>
            <th style="width: 1.0%">Via</th>
            <th style="width: 10%">Dest</th>
            <th style="width: 0.75%">Pax</th>
            <th style="width: 0.25%">Room/Name</th>
            <th style="width: 4%">Att</th>
            <th style="width: 1.25%">Dur</th>
          </tr>
        </thead>
        <tbody v-for="booking in upcomingBookings" style="cursor: pointer;">
          <v-menu
            offset-y
            max-width="200"
            nudge-right="100"
            :close-on-content-click="false"
            v-model="menu[booking.id.toString()]"
          >
            <template v-slot:activator="{ on }">
              <tr
                v-bind:style="styleForUpcomingBookingRow(booking)"
                @click="setSelectedBooking(booking.id, -1);"
                v-on="on"
                valign="top"
              >
                <td>
                  <p
                    v-if="offeredTaxiForBooking(booking) != ''"
                  >{{ offeredTaxiForBooking(booking) }}</p>
                  <div v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div v-on="on" v-html="preassignedDriver(booking)"></div>
                      </template>
                      <p v-html="preassignedDriverName(booking)"></p>
                    </v-tooltip>
                  </div>
                </td>
                <td
                  v-html="timeForBooking(booking.pickup_time ) + '&nbsp-&nbsp;' + dispatchTimeForBooking(booking)"
                ></td>
                <td>
                  <div class="fixed-table-row">{{prettify(booking.pickup_location.description)}}</div>
                </td>
                <td>
                  <ViasForBooking :booking="booking" />
                </td>
                <td>
                  <div class="fixed-table-row">{{destinationForBooking(booking)}}</div>
                </td>
                <td>{{booking.num_people}}</td>
                <td>
                  <div class="fixed-table-row">{{nameOrRoomForCustomerForBooking(booking)}}</div>
                </td>
                <td>
                  <AttributesForBookingCell :booking="booking" />
                </td>
                <td>{{ booking.route != null ? secondsToHoursMinutesString(booking.route.time) : "" }}</td>
              </tr>
            </template>
            <BookingMenu
              @copy="copy(booking)"
              @edit="edit(booking.id)"
              @assign="assign(booking.id)"
              @close="menu[booking.id.toString()] = false"
              @track="setSelectedBooking(booking.id, -1);"
              :booking="booking"
            />
          </v-menu>
        </tbody>
      </table>
    </div>
    <div id="searchcontainer">
      <v-layout row align-center>
        <v-flex xs6>
          <TableSearch ref="tableSearch" table="upcomingTable" />
        </v-flex>
        <p style="display: inline; font-size: 12px;">Hours Ahead&nbsp;&nbsp;</p>
        <input
          @input="hoursToShowChanged"
          style="display: inline; width: 32px; font-size: 12px; background-color: white; padding-left: 4px;"
          type="number"
          v-model="hoursToShow"
        />
      </v-layout>
    </div>
  </div>
</template>

<script>
import BookingMenu from "@/components/widget/menu/BookingMenu.vue";
import AttributesForBookingCell from "@/components/widget/AttributesForBookingCell.vue";
import TableSearch from "@/components/overwatch/TableSearch.vue";

import moment from "moment";
import ViasForBooking from "@/components/overwatch/ViasForBooking.vue";

import { Overwatch } from "@/components/util/Overwatch.js";

import { replaceStart } from "@/components/util/PhoneNumbers.js";

export default {
  name: "upcoming_trip_table",
  components: {
    AttributesForBookingCell,
    TableSearch,
    BookingMenu,
    ViasForBooking
  },
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    taxis: Array,
    bookings: Array,
    setSelectedBooking: Function,
    selectedBooking: Number,
    showAssign: Function,
    hoursToShow: Number
  },
  watch: {
    bookings: function() {
      // console.log("Bookings search");
      this.$refs.tableSearch.searchTable();
    }
  },
  computed: {
    upcomingBookings: function() {
      var upcomingBookings = this.bookings.filter(function(b) {
        return b.state == "booked";
      });

      var sort = this.sortUpcomingBookings;

      return upcomingBookings.sort(sort);
    }
  },
  data() {
    return {
      ABOUT_TO_CLEAR_TIME: 1,
      menu: {}
    };
  },
  methods: {
    nameOrRoomForCustomerForBooking: function(b) {
      var name = Overwatch.nameForCustomerForBooking(b);

      if (b.business_customer_name != null && b.business_customer_name != "") {
        return b.business_customer_name;
      } else if (b.room_number != null && b.room_number != "") {
        return b.room_number;
      } else {
        return b.customer_name;
      }
    },
    formatNumber: function(number) {
      return replaceStart(number);
    },
    hoursToShowChanged: function() {
      this.$emit("changeHoursToShow", Number(this.hoursToShow));
    },
    copy: function(booking) {
      this.$emit("copy", booking);
    },
    edit: function(bookingID) {
      this.$emit("edit", bookingID);
    },
    assign: function(bookingID) {
      this.$emit("assign", bookingID);
    },
    preassignedDriver: function(booking) {
      if (booking.preassigned_driver != null) {
        var preassignedString = "";
        if (
          !new Overwatch(this.taxis, this.bookings).driverIsOnline(
            booking.preassigned_driver.driver.id
          )
        ) {
          preassignedString +=
            "<div style='padding-top: 2px; background-color: #dadada; border-radius: 8px;'><p align='center'>";
        } else {
          preassignedString +=
            "<div style='padding-top: 2px; background-color: white; border-radius: 8px;'><p align='center'>";
        }

        preassignedString +=
          "<b>" + booking.preassigned_driver.driver.callsign + "</b>";

        preassignedString += "</a></div>";

        return preassignedString;
      } else {
        return "";
      }
    },
    preassignedDriverName: function(booking) {
      if (booking.preassigned_driver != null) {
        return booking.preassigned_driver.driver.name;
      } else {
        return "";
      }
    },
    offeredTaxiForBooking: function(booking) {
      var taxiID = null;

      if (
        booking.has_follow_on_offer &&
        booking.follow_on_job_offer_taxis != null
      ) {
        // get follow on taxis for booking
        taxiID = booking.follow_on_job_offer_taxis;
      } else if (booking.offer_taxis != null) {
        taxiID = booking.offer_taxis;
      }

      if (taxiID != null) {
        var taxi = this.taxis.find(function(t) {
          return t.id == taxiID;
        });

        if (taxi != null) {
          return taxi.driver.callsign;
        }
      }

      return "";
    },
    styleForUpcomingBookingRow: function(booking) {
      // if being offered return
      var color = "white";

      if (booking.taxi) {
        color = "#6cffbb";
      } else if (booking.has_follow_on_offer) {
        color = "#6cffbb";
      } else {
        if (booking.asap || booking.estimated_dispatch_timestamp == null) {
          dispatchTimeMillis = booking.pickup_timestamp;
        } else {
          dispatchTimeMillis = booking.estimated_dispatch_timestamp;
        }

        var now = moment(new Date());
        var end = moment(dispatchTimeMillis);

        var dispatchTimeMillis = 0;

        var lateString = "";

        var diff = now.diff(end);

        var duration = moment.duration(diff);

        var minutes = duration.asMinutes();

        // console.log(minutes);

        // 10 minute threshold for running late
        if (booking.asap && minutes >= 9.5) {
          color = "#ff6c6c";
        } else if (!booking.asap && minutes >= -10) {
          color = "#fcbd68";
        }
      }

      var style = {
        "background-color": color
      };

      if (this.selectedBooking == booking.id) {
        style.boxShadow = "inset 0 0 0 99999px rgba(0,0,0,0.1)";
      }

      return style;
    },
    timeForBooking: function(timeString) {
      var time = moment(timeString, "DD/MM/YYYY HH:mm");

      return `${time.format("HH:mm")}`;
    },
    dispatchTimeForBooking: function(booking) {
      if (booking.asap) {
        return "<b class='blink_me' style='color: red'>ASAP</b>";
      }

      var dispatchTimeMillis = 0;

      // if (booking.estimated_dispatch_timestamp == null) {
      dispatchTimeMillis = booking.pickup_timestamp;
      // } else {
      //   dispatchTimeMillis = booking.estimated_dispatch_timestamp;
      // }

      var now = moment(new Date());
      var end = moment(dispatchTimeMillis);

      // console.log(now);
      // console.log(end);

      var lateString = "";

      if (now.isAfter(end)) {
        // lateString = " ago";
      }

      var diff = now.diff(end);

      var duration = moment.duration(diff);

      var lateTimeString = this.durationToHoursMinutesString(duration, "m");

      return lateTimeString + lateString;
    },
    durationToHoursMinutesString: function(duration, minutesString) {
      return Overwatch.durationToHoursMinutesString(duration, minutesString);
    },
    secondsToHoursMinutesString: function(seconds) {
      var duration = moment.duration(seconds, "seconds");

      var hoursMinutesString = this.durationToHoursMinutesString(duration, "m");

      return hoursMinutesString;
    },
    prettify: function(d) {
      return Overwatch.prettifyAddress(d);
    },
    viasForBooking: function(b) {
      return Overwatch.viasForBooking(b);
    },
    destinationForBooking: function(b) {
      return Overwatch.destinationForBooking(b);
    },
    sortUpcomingBookings: function(a, b) {
      // if (
      //   (a.taxi || a.has_follow_on_offer) &&
      //   (!b.taxi && !b.has_follow_on_offer)
      // ) {
      //   return -1;
      // } else if (
      //   (!a.taxi || !a.has_follow_on_offer) &&
      //   (b.taxi && b.has_follow_on_offer)
      // ) {
      //   return 1;
      // } else {
      var dispatchTimeA = 0;
      var dispatchTimeB = 0;

      if (a.asap) {
        dispatchTimeA = a.pickup_timestamp;
      } else {
        if (a.estimated_dispatch_timestamp != null) {
          dispatchTimeA = a.estimated_dispatch_timestamp;
        } else {
          dispatchTimeA = a.pickup_timestamp;
        }
      }

      if (b.asap) {
        dispatchTimeB = b.pickup_timestamp;
      } else {
        if (a.estimated_dispatch_timestamp != null) {
          dispatchTimeB = b.estimated_dispatch_timestamp;
        } else {
          dispatchTimeB = b.pickup_timestamp;
        }
      }

      if (dispatchTimeA < dispatchTimeB) {
        return -1;
      } else if (dispatchTimeA > dispatchTimeB) {
        return 1;
      } else {
        if (a.id < b.id) {
          return -1;
        } else if (a.id > b.id) {
          return 1;
        } else {
          return 0;
        }
      }
      // }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#gridcontainer {
  position: absolute;
  top: 0;
  bottom: 24px;
  left: 0;
  right: 0;
  overflow: auto;
}

#searchcontainer {
  position: absolute;
  width: 100%;
  height: 24px;
  bottom: 0px;
  left: 0;
  padding-top: 1px;
  padding-left: 24px;
  right: 0;
  background-color: #f5f5f5;
}

.upcoming-table {
  font-size: 11px;
}

th {
  text-align: left;
  color: #10425a;
}

th,
td {
  text-align: left;
  padding-left: 8px;
  padding-top: 1px;
}

tr {
  padding-top: 3px !important;
}

table {
  padding: 4px;
  border-collapse: collapse;
}

// tr:nth-child(even) {
//   background-color: #f2f2f2;
// }

tbody:nth-child(even) {
  background-color: #f2f2f2;
}

.via-list {
  list-style: disc !important;
  padding-left: 14px !important;
}

.taxi-list-header {
  color: #10425a;
}

.small-text {
  font-size: 13px;
}

.padding-li {
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 12px;
}

.padding-li:hover {
  background-color: #dedede;
}

.no-text-overflow {
  // overflow: hidden;
  // white-space: nowrap;
  // text-overflow: none;
}

.blink_me {
  animation: blinker 2s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
